
const theme = {
    colors: {
        white: "#fff",
        black: "#444",
        buttons: {
            contact: "#009688",
        }
    },
    fontSize: {
        landingTitle: "90px",
        landingSubTitle: "20px",
        button: "14px",
        mobile: {
            landingTitle: "40px",
            landingSubTitle: "20px",
        }
    }
};

export default theme;